export default "__VITE_ASSET__BYweK1Ez__"